import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

// Force Light Mode before React mounts (no dark flash)
try {
    localStorage.setItem("darkMode", "false");
} catch (e) {}
if (typeof document !== "undefined") {
    document.body.classList.remove("dark-mode");
}

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
